import { useEffect } from 'react';
import { useState } from 'react';
import ReactSlider from 'react-slider';

export const MultiValueRangeSlider = ({ handleChange, maxValue, minValue, lowerLimit, upperLimit, leftThumbFormattedString, rightThumbFormattedString, step, preventZeroCrossover }) => {
    
    const [valueLeftThumb, setValueLeftThumb] = useState(minValue);
    const [valueRightThumb, setValueRightThumb] = useState(maxValue);

    useEffect(() => {
        setValueLeftThumb(minValue);
        setValueRightThumb(maxValue);
    }, [minValue, maxValue]);

    const onChange = (value) => {
        if (preventZeroCrossover && value[0] > minValue && value[0] > 0) {
            setValueLeftThumb(0)
        } else if (preventZeroCrossover && value[1] < maxValue && value[1] < 0) {
            setValueRightThumb(0)
        } else {
            setValueLeftThumb(value[0])
            setValueRightThumb(value[1])
        }
    }

    useEffect(() => handleChange([valueLeftThumb, valueRightThumb]), [valueLeftThumb, valueRightThumb])

    return (
        <>
            <div className='w-100 mt-3'>
                <ReactSlider
                    className='range-slider'
                    thumbClassName='range-slider-handle'
                    trackClassName='range-slider-track'
                    min={-lowerLimit}
                    max={upperLimit}
                    value={[valueLeftThumb, valueRightThumb]}
                    ariaLabel={['Lower handle', 'Upper handle']}
                    ariaValuetext={state => `Handle value ${state.valueNow}`}
                    step={step}
                    renderThumb={(props, state) =>
                        <div {...props}>
                            <div
                                className='range-slider-tooltip'>{state.index === 0 ? leftThumbFormattedString : rightThumbFormattedString}</div>
                        </div>
                    }
                    pearling
                    minDistance={0}
                    onChange={onChange}
                />
            </div>
        </>
    )
}